import { FC, useEffect, useState } from 'react';

import { Input, Modal } from '@/shared/design-system';

import { ModalBody } from '../styled';

export type RoleNameModalProps = {
  open: boolean;
  title: string;
  description: string;
  confirmLabel: string;
  /** Prefilled name, e.g. "Approver (copy)" when duplicating. */
  initialName?: string;
  isPending?: boolean;
  onConfirm: (_name: string) => void;
  onClose: () => void;
};

/** Shared by "New role" and "Duplicate role" — both are just a name and a confirm. */
export const RoleNameModal: FC<RoleNameModalProps> = ({
  open,
  title,
  description,
  confirmLabel,
  initialName = '',
  isPending,
  onConfirm,
  onClose,
}) => {
  const [name, setName] = useState(initialName);

  useEffect(() => {
    if (open) setName(initialName);
  }, [open, initialName]);

  const trimmed = name.trim();

  return (
    <Modal
      open={open}
      onOpenChange={(isOpen) => !isOpen && onClose()}
      title={title}
      description={description}
      primaryAction={{
        label: isPending ? 'Saving…' : confirmLabel,
        onClick: () => trimmed && onConfirm(trimmed),
      }}
      secondaryAction={{ label: 'Cancel', onClick: onClose }}
    >
      <ModalBody>
        <Input
          size="md"
          label="Role name"
          value={name}
          placeholder="e.g. Fund operations"
          onChange={(event) => setName(event.target.value)}
        />
      </ModalBody>
    </Modal>
  );
};
